var _polygon, _polygon2, _path, _polygon3, _polygon4, _polygon5, _polygon6, _path2, _path3, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _path4, _polygon11, _path5, _polygon12, _polygon13, _polygon14, _path6, _g, _polygon15, _path7, _polygon16, _polygon17, _path8, _path9, _polygon18, _polygon19, _polygon20, _polygon21, _path0, _polygon22, _path1, _polygon23, _polygon24, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessDeniedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Color",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF7F00",
    points: "136.501,476.5 136.501,500.5 8.501,500.5 8.501,476.5 16.501,476.5 128.501,476.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF7F00",
    points: "107.221,412.5 117.861,444.5 27.141,444.5 37.781,412.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F00",
    d: "M91.221,364.5l5.28,16h-48l5.28-16l3.52-10.48c4.88-14.56,25.52-14.56,30.4,0L91.221,364.5z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "107.221,412.5 37.781,412.5 48.501,380.5 96.501,380.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "117.861,444.5 128.501,476.5 16.501,476.5 27.141,444.5 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "485.861,444.5 496.501,476.5 384.501,476.5 395.141,444.5 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "475.221,412.5 405.781,412.5 416.501,380.5 464.501,380.5 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M504.501,76.5v288h-45.28l-3.52-10.48c-4.24-12.64-20.4-14.32-27.76-4.96l60.56-272.56H504.501z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M467.853,352.5l-0.773-2.297c-3.5-10.422-12.273-17.531-22.906-18.867l48.328-217.516V352.5H467.853z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "408.501,76.5 344.501,364.5 264.501,364.5 328.501,76.5 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "279.462,352.5 338.126,88.5 393.54,88.5 334.876,352.5 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "248.501,76.5 184.501,364.5 104.501,364.5 168.501,76.5 "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "119.462,352.5 178.126,88.5 233.54,88.5 174.876,352.5 "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF7F00",
    points: "504.501,476.5 504.501,500.5 376.501,500.5 376.501,476.5 384.501,476.5 496.501,476.5 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF5500",
    points: "504.501,476.5 504.501,500.5 464.501,500.5 464.501,476.5 467.001,476.5 502.001,476.5 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F00",
    d: "M488.501,76.5l-60.56,272.56c-1.12,1.44-2,3.04-2.64,4.96l-3.52,10.48h-77.28l64-288H488.501z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF7F00",
    points: "475.221,412.5 485.861,444.5 395.141,444.5 405.781,412.5 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F00",
    d: "M459.221,364.5l5.28,16h-48l5.28-16l3.52-10.48c0.64-1.92,1.52-3.52,2.64-4.96 c7.36-9.36,23.52-7.68,27.76,4.96L459.221,364.5z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCCCCC",
    points: "496.501,476.5 462.821,476.5 457.301,444.5 485.861,444.5 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCCCCC",
    points: "475.221,412.5 451.781,412.5 446.261,380.5 464.501,380.5 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF5500",
    points: "485.861,444.5 457.301,444.5 451.781,412.5 475.221,412.5 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5500",
    d: "M464.501,380.5h-18.24l-6.4-37.36c6.56-0.24,13.28,3.36,15.84,10.88l3.52,10.48L464.501,380.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF5500",
    points: "136.501,476.5 136.501,500.5 96.501,500.5 96.501,476.5 99.001,476.5 134.001,476.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCCCCC",
    points: "128.501,476.5 94.821,476.5 89.301,444.5 117.861,444.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCCCCC",
    points: "107.221,412.5 83.781,412.5 78.261,380.5 96.501,380.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF5500",
    points: "117.861,444.5 89.301,444.5 83.781,412.5 107.221,412.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5500",
    d: "M96.501,380.5h-18.24l-6.4-37.36c6.56-0.24,13.28,3.36,15.84,10.88l3.52,10.48L96.501,380.5z"
  }))), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF7F00",
    points: "328.501,76.5 264.501,364.5 184.501,364.5 248.501,76.5 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F00",
    d: "M168.501,76.5l-64,288h-13.28l-3.52-10.48c-4.88-14.56-25.52-14.56-30.4,0l-3.52,10.48h-29.28l64-288 H168.501z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "88.501,76.5 24.501,364.5 8.501,364.5 8.501,76.5 "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "20.501,88.5 73.54,88.5 20.501,327.18 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M504.501,76.5v288h-45.28l-3.52-10.48c-4.24-12.64-20.4-14.32-27.76-4.96l10.32-46.56 c6.08-5.04,11.52-10.88,16.16-17.28l-10.24,46.08c10.64,1.36,19.36,8.48,22.88,18.88l0.8,2.32h24.64V113.86l-20,90V148.5l16-72 H504.501z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M492.501,113.86V352.5h-24.64l-0.8-2.32c-3.52-10.4-12.24-17.52-22.88-18.88l10.24-46.08 c11.36-15.68,18.08-34.96,18.08-55.84v-25.52L492.501,113.86z"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCCCCC",
    points: "353.381,324.5 344.501,364.5 264.501,364.5 273.381,324.5 285.701,324.5 279.461,352.5  334.901,352.5 341.141,324.5 "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "341.141,324.5 334.901,352.5 279.461,352.5 285.701,324.5 "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCCCCC",
    points: "193.381,324.5 184.501,364.5 104.501,364.5 113.381,324.5 125.701,324.5 119.461,352.5  174.901,352.5 181.141,324.5 "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "181.141,324.5 174.901,352.5 119.461,352.5 125.701,324.5 "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5500",
    d: "M438.261,302.5l-10.32,46.56c-1.12,1.44-2,3.04-2.64,4.96l-3.52,10.48h-77.28l8.88-40h24 C400.581,324.5,421.781,316.26,438.261,302.5z"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF5500",
    points: "273.381,324.5 264.501,364.5 184.501,364.5 193.381,324.5 "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5500",
    d: "M113.381,324.5l-8.88,40h-13.28l-3.52-10.48c-4.88-14.56-25.52-14.56-30.4,0l-3.52,10.48h-29.28l8.88-40 H113.381z"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCCCCC",
    points: "33.381,324.5 24.501,364.5 8.501,364.5 8.501,324.5 "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "20.501,88.5 73.54,88.5 20.501,327.18 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#472B3C",
    d: "M504.501,68.5h-496c-4.422,0-8,3.578-8,8v288c0,4.422,3.578,8,8,8h34.237l-32,96H8.501c-4.422,0-8,3.578-8,8 v24c0,4.422,3.578,8,8,8h128c4.422,0,8-3.578,8-8v-24c0-4.422-3.578-8-8-8h-2.237l-31.994-96h308.467l-32,96h-2.237 c-4.422,0-8,3.578-8,8v24c0,4.422,3.578,8,8,8h128c4.422,0,8-3.578,8-8v-24c0-4.422-3.578-8-8-8h-2.237l-31.994-96h34.23 c4.422,0,8-3.578,8-8v-288C512.501,72.078,508.923,68.5,504.501,68.5z M116.9,308.688c-4.281-0.891-8.586,1.766-9.547,6.078 L98.081,356.5H96.97l-1.68-5.023c-3.336-9.945-12.281-16.375-22.789-16.375s-19.453,6.43-22.789,16.375l-1.68,5.023H34.477 l60.444-272h63.604L114.47,282.766c-0.953,4.312,1.766,8.586,6.078,9.547c0.586,0.125,1.164,0.188,1.742,0.188 c3.664,0,6.977-2.539,7.805-6.266L174.922,84.5h63.604l-60.444,272h-63.605l8.501-38.266 C123.931,313.922,121.212,309.648,116.9,308.688z M106.738,436.5H38.267l5.334-16h57.804L106.738,436.5z M48.936,404.5l5.334-16 h36.468l5.333,16H48.936z M80.095,356.57l5.31,15.93H59.604l5.311-15.93c1.688-5.078,6.234-5.469,7.586-5.469 S78.4,351.492,80.095,356.57z M254.921,84.5h63.605l-60.444,272h-63.605L254.921,84.5z M334.921,84.5h63.604l-60.444,272h-63.604 L334.921,84.5z M16.501,84.5h62.024l-60.444,272h-1.58V84.5z M128.501,492.5h-112v-8h112V492.5z M27.598,468.5l5.334-16h79.139 l5.333,16H27.598z M474.738,436.5h-68.471l5.334-16h57.804L474.738,436.5z M416.936,404.5l5.334-16h36.468l5.333,16H416.936z  M427.604,372.5l5.311-15.93c1.688-5.078,6.234-5.469,7.586-5.469s5.898,0.391,7.594,5.469l5.31,15.93H427.604z M496.501,492.5h-112 v-8h112V492.5z M395.598,468.5l5.334-16h79.139l5.333,16H395.598z M496.501,356.5h-31.563l-1.664-4.992 c-3.328-9.969-12.266-16.406-22.773-16.406s-19.445,6.438-22.766,16.406l-1.664,4.992h-61.595l60.444-272h63.604l-45.837,206.297 c-0.953,4.312,1.766,8.586,6.078,9.547c0.586,0.125,1.164,0.188,1.742,0.188c3.664,0,6.977-2.539,7.805-6.266L494.922,84.5h1.58 V356.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDeniedIcon);
export default __webpack_public_path__ + "static/media/access-denied-icon.5bb26b07630fefc1ab1c3abb25a277be.svg";
export { ForwardRef as ReactComponent };